import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const SaleInvoiceModifierDialogTourConfig: AgTechTourConfig = {
    id: 'sale-invoice-modifier-dialog-tour',
    name: 'Charge or Discount Tour',
    steps: [
        {
            targetId: 'invoice-modifier-name',
            title: 'Name and Category',
            description: 'Give the modifier a name that will appear on invoices, and choose whether it is a Charge (adds to the total, like a fee) or a Discount (reduces it).',
            position: 'bottom',
        },
        {
            targetId: 'invoice-modifier-amount',
            title: 'Amount',
            description: 'Enter the amount. Turn on Is Percentage to apply it as a percentage of the lot total (up to 100) instead of a fixed dollar amount.',
            position: 'top',
        },
    ]
}
